import IconHome from "../../../../styles/icons/IconHome";
import { ActiveColorGenerator } from "../../../../utils/helpers/helperMethods/NavigationControllersHelper";
import { Link } from "react-router-dom";
import { Col } from "react-bootstrap";

interface Props {
  index: number;
  title: string;
  count: string | number;
  className: string;
  icon?: string | undefined;
  width?: string;
  height?: string;
  url: string;
  subTitle?: string;
}
const HighlightCard = (props: Props) => {
  const { index, title, count, className, icon, url, subTitle } = props;
  return (
    <Col sm={6} md={3} lg={3} className={`highlight-card ${className}`}>
      <Link key={index} to={url}>
        <div className="text-wrapper">
          <div className="title">
            <div className="icon-wrapper">
              {icon && (
                <IconHome
                  breadcrumb={icon!}
                  activeColor={ActiveColorGenerator("", icon!)}
                />
              )}{" "}
            </div>
            <div>{title}</div>
          </div>
          <div className="count">{count}</div>
          <p className="sub-title">{subTitle}</p>
        </div>
      </Link>
    </Col>
  );
};

export default HighlightCard;
